import { render, staticRenderFns } from "./DeleteWarning.vue?vue&type=template&id=5a5f365a"
import script from "./DeleteWarning.vue?vue&type=script&lang=ts"
export * from "./DeleteWarning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports